/**
 * @packageDocumentation
 * @module HackerAPI.Event.ScheduleItem
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * Data container for a schedule item
 * @class
 * @extends { HackerAPI.Base }
 */
var ScheduleItem = /** @class */ (function (_super) {
    __extends(ScheduleItem, _super);
    /**
     * Creates a new schedule item
     * @constructor
     * @param scheduleItem
     */
    function ScheduleItem(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, title = _b.title, description = _b.description, start_time = _b.start_time, startTime = _b.startTime, end_time = _b.end_time, endTime = _b.endTime, location = _b.location, tags = _b.tags, links = _b.links, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this, {
            startTime: Base.dateTimeHandler,
            endTime: Base.dateTimeHandler
        }) || this;
        /**
         * The ID of the schedule item
         * @type { number }
         */
        _this.id = id;
        /**
         * The title of the schedule item
         * @type { number }
         */
        _this.title = title;
        /**
         * The description of the schedule item (optional)
         * @type { string }
         */
        _this.description = description;
        /**
         * The start time of the schedule item
         * @type { Date }
         */
        _this.startTime = parseDate(start_time || startTime);
        /**
         * The end time of the schedule item
         * @type { Date }
         */
        _this.endTime = parseDate(end_time || endTime);
        /**
         * The location of the schedule item
         * @type { string }
         */
        _this.location = location;
        /**
         * Tags associated with the schedule item
         * @type { string[] }
         */
        _this.tags = tags;
        /**
         * Useful links
         * @type { string[] }
         */
        _this.links = links;
        /**
         * When the schedule item was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the schedule item was updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Gets the schedule for an event
     * @param event
     * @param event.slug
     * @returns
     */
    ScheduleItem.fetchAll = function (_a) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/schedule",
            method: "GET"
        }).then(function (data) {
            return data.map(function (datum) { return new ScheduleItem(datum); });
        });
    };
    /**
     * Gets an item on the schedule
     * @param event
     * @param event.slug
     * @param item
     * @param item.id
     * @returns
     */
    ScheduleItem.fetch = function (_a, _b) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/schedule/" + id,
            method: "GET"
        }).then(function (data) { return new ScheduleItem(data); });
    };
    /**
     * Adds a schedule item to the schedule
     * @param event
     * @param event.slug
     * @param { HackerAPI.ScheduleItem} scheduleItem
     * @param token
     * @returns The server response
     */
    ScheduleItem.create = function (_a, scheduleItem, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/schedule",
            method: "POST",
            body: scheduleItem.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new ScheduleItem(data); });
    };
    /**
     * Updates a schedule item on the schedule
     * @param event
     * @param event.slug
     * @param { HackerAPI.ScheduleItem} scheduleItem
     * @param token
     * @returns The server response
     */
    ScheduleItem.update = function (_a, scheduleItem, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/schedule/" + scheduleItem.id,
            method: "PUT",
            body: scheduleItem.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new ScheduleItem(data); });
    };
    /**
     * Deletes a schedule item
     * @param event
     * @param event.slug
     * @param item
     * @param item.id
     * @param token
     * @returns
     */
    ScheduleItem.delete = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/schedule/" + id,
            method: "DELETE",
            token: token
        });
    };
    return ScheduleItem;
}(Base));
export default ScheduleItem;
//# sourceMappingURL=schedule-item.js.map